import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn } from '../shared/interface/generic-interface';

@Injectable({
  providedIn: 'root'
})
export class StatusDasEntregasService {

  constructor(
    private apiConService: ApiConService
  ) { }


  async getStatusDeEntregas(roteiros: String){
    let response: JsonReturn = await this.apiConService.patch(`DCroteiroPedido/pedido/statusDeEntregas/${roteiros}`)
    return response.response;
  }

}
